import styled from "styled-components";

type CountdownCircleProps = {
  countdown: number;
  max: number;
  size?: number;
};

export const CountdownCircle = ({
  countdown,
  max,
  size = 24,
}: CountdownCircleProps) => {
  const r = (size - 4) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circ = 2 * Math.PI * r;
  const progress = (countdown / max) * circ;
  const fontSize = Math.max(8, size * 0.3); // Scale font size based on circle size

  return (
    <Svg width={size} height={size}>
      <CircleBG cx={cx} cy={cy} r={r} />
      <CircleProgress
        cx={cx}
        cy={cy}
        r={r}
        strokeDasharray={circ}
        strokeDashoffset={circ - progress}
      />
      <CircleText x={cx} y={cy + fontSize * 0.4} fontSize={fontSize}>
        {countdown}
      </CircleText>
    </Svg>
  );
};

const Svg = styled.svg`
  display: block;
`;

const CircleBG = styled.circle`
  fill: none;
  stroke: rgb(0, 0, 0, 0.8);
  stroke-width: 2;
`;

const CircleProgress = styled.circle`
  color: ${({ theme }) => theme.colors.envy};
  fill: none;
  stroke: ${({ theme }) => theme.colors.envy};
  stroke-width: 2;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: center;
  transition: stroke-dashoffset 1s linear;
`;

const CircleText = styled.text<{ fontSize: number }>`
  fill: ${({ theme }) => theme.colors.envy};
  font-size: ${({ fontSize }) => fontSize}px;
  text-anchor: middle;
  font-family: sans-serif;
`;
